import Button from '@material-ui/core/Button'
import EditModeOnly from 'Event/Dashboard/editor/views/EditModeOnly'
import React from 'react'
import styled from 'styled-components'
import {SimpleBlog, useSimpleBlogTemplate} from 'Event/template/SimpleBlog'
import {Publishable} from 'Event/Dashboard/editor/views/Published'
import Published from 'Event/Dashboard/editor/views/Published'
import {useToggle} from 'lib/toggle'
import {SidebarContainerConfig} from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarContainer/SidebarContainerConfig'
import {SectionBox} from 'Event/template/SimpleBlog/Dashboard/Sidebar/Section'

export type Sidebar = Publishable & {
  backgroundImage: string | null
  background: string
  textColor: string | null
  borderRadius: number
  borderWidth: number
  borderColor: string
  paddingTop?: number
  separatorColor?: string
  separatorThickness?: number
  separatorStyle?: 'solid' | 'dashed' | 'dotted'
  itemSpacing: number
}

export default function SidebarContainer(props: {children: React.ReactNode}) {
  const template = useSimpleBlogTemplate()
  const {sidebar, textColor} = template

  const {flag: configVisible, toggle: toggleConfig} = useToggle()

  return (
    <>
      <EditModeOnly>
        <SidebarContainerConfig
          showing={configVisible}
          onClose={toggleConfig}
        />
      </EditModeOnly>
      <Published component={sidebar}>
        <Box {...sidebar}>
          <TopLayer textColor={textColor} sidebarTextColor={sidebar.textColor}>
            <EditModeOnly>
              <SectionBox disablePaddingTop>
                <Button
                  onClick={toggleConfig}
                  fullWidth
                  size="large"
                  variant="contained"
                  color="secondary"
                  aria-label="edit sidebar"
                >
                  Edit Sidebar
                </Button>
              </SectionBox>
            </EditModeOnly>
            {props.children}
          </TopLayer>
        </Box>
      </Published>
    </>
  )
}

const Box = styled.div<SimpleBlog['sidebar']>`
  background: ${(props) => props.background};
  background-image: url(${(props) => props.backgroundImage});
  background-position: center center;
  background-size: cover;
  position: relative;
  padding: ${(props) => `${props.theme.spacing[12]} 0`};
  ${(props) =>
    props.paddingTop !== undefined ? `padding-top: ${props.paddingTop}px;` : ``}
  border-radius: ${(props) => props.borderRadius}px;
  border: ${(props) => props.borderWidth}px solid
    ${(props) => props.borderColor};
  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    height: 100%;
  }
`

const TopLayer = styled.div<{
  textColor: string
  sidebarTextColor: string | null
}>`
  color: ${(props) =>
    props.sidebarTextColor
      ? props.sidebarTextColor
      : props.textColor} !important;
  position: relative;
  z-index: 2;
`
